/**
 * Analytics loader — attiva Plausible, Google Analytics 4 e Facebook Pixel
 * solo se le rispettive variabili d'ambiente sono configurate.
 *
 * Variabili supportate (frontend/.env):
 *   REACT_APP_PLAUSIBLE_DOMAIN=agrinexus.it
 *   REACT_APP_GA_ID=G-XXXXXXXXXX
 *   REACT_APP_FB_PIXEL_ID=123456789012345
 *
 * Se una env non è impostata, quel provider viene semplicemente saltato.
 * Zero costi, zero tracker inutili quando non configurato.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PLAUSIBLE_DOMAIN = process.env.REACT_APP_PLAUSIBLE_DOMAIN;
const GA_ID = process.env.REACT_APP_GA_ID;
const FB_PIXEL_ID = process.env.REACT_APP_FB_PIXEL_ID;

let injected = false;

function injectScripts() {
  if (injected) return;
  injected = true;

  // Plausible (privacy-friendly, no cookie banner needed)
  if (PLAUSIBLE_DOMAIN) {
    const s = document.createElement('script');
    s.defer = true;
    s.setAttribute('data-domain', PLAUSIBLE_DOMAIN);
    s.src = 'https://plausible.io/js/script.tagged-events.js';
    document.head.appendChild(s);
    window.plausible = window.plausible || function(){(window.plausible.q = window.plausible.q || []).push(arguments)};
  }

  // Google Analytics 4
  if (GA_ID) {
    const s1 = document.createElement('script');
    s1.async = true;
    s1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s1);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function(){ window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', GA_ID, { anonymize_ip: true, send_page_view: false });
  }

  // Facebook Pixel
  if (FB_PIXEL_ID) {
    /* eslint-disable */
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', FB_PIXEL_ID);
    /* eslint-enable */
  }
}

/** Fire pageview su change route */
export function usePageviewTracking() {
  const loc = useLocation();
  useEffect(() => {
    injectScripts();
    const url = loc.pathname + loc.search;
    if (window.plausible) window.plausible('pageview');
    if (window.gtag && GA_ID) window.gtag('event', 'page_view', { page_path: url });
    if (window.fbq) window.fbq('track', 'PageView');
  }, [loc.pathname, loc.search]);
}

/** Fire custom event (es. contact_whatsapp, publish_listing, register). */
export function track(name, props = {}) {
  try {
    if (window.plausible) window.plausible(name, { props });
    if (window.gtag) window.gtag('event', name, props);
    if (window.fbq) window.fbq('trackCustom', name, props);
  } catch (_) {/* silent */}
}
